export const F6_TOPICS = ['ROLE', 'EXPERIENCES', 'MONEY', 'TALK', 'SHARING', 'TEMPO'];
export const F6_VERSION = 'F6';
export const F6_INSTRUCTION = "Pick what feels most like you.";
export const F6_QUESTIONS = {
    ROLE: "In a group, which describes you best?",
    EXPERIENCES: "Which describes your approach to new experiences and challenges?",
    MONEY: "When it comes to money and possessions, which describes you best?",
    TALK: "In conversations and disagreements, which describes you best?",
    SHARING: "When letting others get to know you, which describes you best?",
    TEMPO: "With plans, goals and routines, which describes you best?",
};
/** the catalogue in the approved order; ids are permanent (see above) */
export const F6_TAGS = [
    { id: 'role.performer', topic: 'ROLE', label: "Performer", ord: 0 },
    { id: 'role.joker', topic: 'ROLE', label: "Joker", ord: 1 },
    { id: 'role.storyteller', topic: 'ROLE', label: "Storyteller", ord: 2 },
    { id: 'role.icebreaker', topic: 'ROLE', label: "Icebreaker", ord: 3 },
    { id: 'role.leader', topic: 'ROLE', label: "Leader", ord: 4 },
    { id: 'role.motivator', topic: 'ROLE', label: "Motivator", ord: 5 },
    { id: 'role.sociable', topic: 'ROLE', label: "Sociable", ord: 6 },
    { id: 'role.team-player', topic: 'ROLE', label: "Team player", ord: 7 },
    { id: 'role.caretaker', topic: 'ROLE', label: "Caretaker", ord: 8 },
    { id: 'role.listener', topic: 'ROLE', label: "Listener", ord: 9 },
    { id: 'role.observer', topic: 'ROLE', label: "Observer", ord: 10 },
    { id: 'role.lone-wolf', topic: 'ROLE', label: "Lone wolf", ord: 11 },
    { id: 'role.rebel', topic: 'ROLE', label: "Rebel", ord: 12 },
    { id: 'experiences.daredevil', topic: 'EXPERIENCES', label: "Daredevil", ord: 0 },
    { id: 'experiences.competitive', topic: 'EXPERIENCES', label: "Competitive", ord: 1 },
    { id: 'experiences.explorer', topic: 'EXPERIENCES', label: "Explorer", ord: 2 },
    { id: 'experiences.curious', topic: 'EXPERIENCES', label: "Curious", ord: 3 },
    { id: 'experiences.dreamer', topic: 'EXPERIENCES', label: "Dreamer", ord: 4 },
    { id: 'experiences.skeptic', topic: 'EXPERIENCES', label: "Skeptic", ord: 5 },
    { id: 'experiences.overthinker', topic: 'EXPERIENCES', label: "Overthinker", ord: 6 },
    { id: 'experiences.cautious', topic: 'EXPERIENCES', label: "Cautious", ord: 7 },
    { id: 'experiences.homebody', topic: 'EXPERIENCES', label: "Homebody", ord: 8 },
    { id: 'money.saver', topic: 'MONEY', label: "Saver", ord: 0 },
    { id: 'money.thrifty', topic: 'MONEY', label: "Thrifty", ord: 1 },
    { id: 'money.spender', topic: 'MONEY', label: "Spender", ord: 2 },
    { id: 'money.generous', topic: 'MONEY', label: "Generous", ord: 3 },
    { id: 'money.investor', topic: 'MONEY', label: "Investor", ord: 4 },
    { id: 'money.minimalist', topic: 'MONEY', label: "Minimalist", ord: 5 },
    { id: 'money.deal-hunter', topic: 'MONEY', label: "Deal hunter", ord: 6 },
    { id: 'money.collector', topic: 'MONEY', label: "Collector", ord: 7 },
    { id: 'talk.direct', topic: 'TALK', label: "Direct", ord: 0 },
    { id: 'talk.diplomat', topic: 'TALK', label: "Diplomat", ord: 1 },
    { id: 'talk.peaceful', topic: 'TALK', label: "Peaceful", ord: 2 },
    { id: 'talk.debater', topic: 'TALK', label: "Debater", ord: 3 },
    { id: 'talk.fiery', topic: 'TALK', label: "Fiery", ord: 4 },
    { id: 'talk.stubborn', topic: 'TALK', label: "Stubborn", ord: 5 },
    { id: 'talk.logical', topic: 'TALK', label: "Logical", ord: 6 },
    { id: 'talk.sarcastic', topic: 'TALK', label: "Sarcastic", ord: 7 },
    { id: 'talk.playful', topic: 'TALK', label: "Playful", ord: 8 },
    { id: 'talk.quiet', topic: 'TALK', label: "Quiet", ord: 9 },
    { id: 'talk.chatty', topic: 'TALK', label: "Chatty", ord: 10 },
    { id: 'sharing.open-book', topic: 'SHARING', label: "Open book", ord: 0 },
    { id: 'sharing.oversharer', topic: 'SHARING', label: "Oversharer", ord: 1 },
    { id: 'sharing.expressive', topic: 'SHARING', label: "Expressive", ord: 2 },
    { id: 'sharing.trusting', topic: 'SHARING', label: "Trusting", ord: 3 },
    { id: 'sharing.selective', topic: 'SHARING', label: "Selective", ord: 4 },
    { id: 'sharing.reserved', topic: 'SHARING', label: "Reserved", ord: 5 },
    { id: 'sharing.shy', topic: 'SHARING', label: "Shy", ord: 6 },
    { id: 'sharing.private', topic: 'SHARING', label: "Private", ord: 7 },
    { id: 'tempo.planner', topic: 'TEMPO', label: "Planner", ord: 0 },
    { id: 'tempo.steady', topic: 'TEMPO', label: "Steady", ord: 1 },
    { id: 'tempo.driven', topic: 'TEMPO', label: "Driven", ord: 2 },
    { id: 'tempo.adaptable', topic: 'TEMPO', label: "Adaptable", ord: 3 },
    { id: 'tempo.laid-back', topic: 'TEMPO', label: "Laid-back", ord: 4 },
    { id: 'tempo.free-spirit', topic: 'TEMPO', label: "Free spirit", ord: 5 },
    { id: 'tempo.spontaneous', topic: 'TEMPO', label: "Spontaneous", ord: 6 },
    { id: 'tempo.last-minute', topic: 'TEMPO', label: "Last-minute", ord: 7 },
    { id: 'tempo.impulsive', topic: 'TEMPO', label: "Impulsive", ord: 8 },
    { id: 'tempo.night-owl', topic: 'TEMPO', label: "Night owl", ord: 9 },
    { id: 'tempo.early-bird', topic: 'TEMPO', label: "Early bird", ord: 10 },
];
const BY_ID = new Map(F6_TAGS.map((t) => [t.id, t]));
export const f6Tag = (id) => BY_ID.get(id);
export const f6TagsOf = (topic) => F6_TAGS.filter((t) => t.topic === topic);
/** every topic chosen, every id a real tag of that topic */
export const f6Complete = (s) => !!s && F6_TOPICS.every((t) => { const id = s[t]; return typeof id === 'string' && BY_ID.get(id)?.topic === t; });
/** the problems with a selection, for the server's refusal: unknown ids, ids under the wrong topic */
export const f6Problems = (s) => {
    const out = [];
    for (const [topic, id] of Object.entries(s)) {
        if (!F6_TOPICS.includes(topic)) {
            out.push(`unknown topic ${topic}`);
            continue;
        }
        if (id === undefined)
            continue;
        const t = BY_ID.get(id);
        if (!t)
            out.push(`unknown tag ${id}`);
        else if (t.topic !== topic)
            out.push(`${id} is a ${t.topic} tag, not ${topic}`);
    }
    return out;
};
/** the six words for the card, in the card's order — only for a complete selection */
export const f6Words = (s) => F6_TOPICS.map((t) => BY_ID.get(s[t]).label);
//# sourceMappingURL=f6.js.map